var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.39 5.044a1 1 0 010 1.732L2.14 11.54a1 1 0 01-1.5-.866V1.147a1 1 0 011.5-.866l8.25 4.763z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "media/video/play-button-d1d6d941.svg";
export { SvgPlayButton as ReactComponent };